import React from 'react';
import s from '../../CartItem.scss';
import {CartItemDataHook} from '../../CartItem';
import {LineItemModel} from '../../../../../../domain/models/LineItems/LineItem.model';

export const Price = ({
  lineItem,
  shouldShowCrossedOutPriceOnLineItemLevel,
}: {
  lineItem: LineItemModel;
  shouldShowCrossedOutPriceOnLineItemLevel: boolean;
}) => {
  return (
    <div className={s.prices}>
      {!shouldShowCrossedOutPriceOnLineItemLevel &&
        lineItem.pricing.breakdown.comparePrice?.formattedConvertedAmount && (
          <span
            data-hook={CartItemDataHook.ComparePrice}
            data-wix-line-full-item-price={CartItemDataHook.ComparePrice}
            className={s.comparePrice}>
            {lineItem.pricing.breakdown.comparePrice.formattedConvertedAmount}
          </span>
        )}
      {lineItem.pricing.unitPrice.formattedConvertedAmount && (
        <span data-hook={CartItemDataHook.Price} className={s.price} data-wix-line-item-price={CartItemDataHook.Price}>
          {lineItem.pricing.breakdown.basePrice.formattedConvertedAmount}
        </span>
      )}
    </div>
  );
};
